import { render } from "./DocLibraryControls.vue?vue&type=template&id=a5570cac&scoped=true"
import script from "./DocLibraryControls.vue?vue&type=script&lang=js"
export * from "./DocLibraryControls.vue?vue&type=script&lang=js"

import "./DocLibraryControls.vue?vue&type=style&index=0&id=a5570cac&scoped=true&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5570cac"]])

export default __exports__